import React, {Component} from 'react';
import TableHolderCustom from './table-holder-custom';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import moment from 'moment-timezone';
import DateRangePickerFilter from './date-range2';
import Utils from "../../Utils/Utility";
import OrderDetail from './../order/order-detail';
import ExportOrder from './export-order';
import CONFIG_HELPER from './../../../ConfigHelper';
import Search_Icon from "../../../img/prev.png";

import Modal from './../generic/modal';

const columns = {
    'orderNum': {type: 'string', label: 'Order#'},
    'name': {type: 'string', label: 'Customer'},
    'userType': {type: 'boolean', label: 'User Type'},
    'totalAmount': {type: 'number', label: 'Amount', prefix: '$'},
    'createdAt': {type: 'string', label: 'Placed'},
    'scheduledAt': {type: 'string', label: 'Scheduled'},
    'orderType': {type: 'string', label: 'Order Type'},
    'orderState': {type: 'string', label: 'Status'},
    'orderItems': {type: 'string', label: 'Details'}
};

const PICKUP = "PickUp";
const DELIVERY = "Delivery";
const DINEIN= "DineIn";
const CURBSIDE_PICKUP = "Curbside Pickup";
const CREATED = "Created";
const ACCEPTED = "Accepted";
const REJECTED = "Rejected";
const NOT_COMPLETED = "NotCompleted";
const PICKED_UP = "PickedUp";
const READY_FOR_PICKUP = "ReadyForPickUp";
const DELIVERED = "Delivered";
const OUT_FOR_DELIVERY = "OutForDelivery";

export default class Stats2Table extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            ordersData      : [],
            isLoaded       : true,
            activeLocation : null,
            fromDate       : this.setLocationTimeZoneInMoment(),
            toDate         : this.setLocationTimeZoneInMoment(),
            timeZone       : null,
            showOrderModal : false,
            showExportModal: false,
            order          : [],
            chargeData     : {},
            maxToDate      : '',
            isPrevBtnActive: 'disabled',
            isNextBtnActive: 'disabled',
            limit          : CONFIG_HELPER.DEFAULT_ORDER_LIMIT,
            skip           : 0,
            pagination     : false,
            totalOrderCount: 0,
            stripeUserId : null,
            showOrderRecord: false,
            showChargeDetails: false
        };

        this._bind(
            'initializeDateTime',
            'fetchOrderDetails',
            'fetchOrderDetails',
            'onDateSelectionChanged',
            'btnPrevClick',
            'btnNextClick',
            'setPrevAndNextBtnClass',
            'parseOrderData',
            'setLocationTimeZoneInMoment',
            'loadChargeModalPopup',
            'getLocationDetailWithPvtConfig'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    initializeDateTime(){

        let self = this;

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);

        defaultFromDate.setDate(defaultFromDate.getDate() - 6);
        defaultFromDate.setHours(0, 0, 0, 0);

        defaultToDate.setHours(23, 59, 59, 0);


        this.setState({
            ordersData      : [],
            fromDate       : defaultFromDate,
            toDate         : defaultToDate,
            order          : [],
            limit          : CONFIG_HELPER.DEFAULT_ORDER_LIMIT,
            skip           : 0,
            pagination     : false,
            totalOrderCount: 0,
            showOrderRecord: true
        },()=>{
            Utils.isUserSessionInvalid().then((response) => {
                self.fetchOrderDetails();
                self.fetchLocationDetails();
            }, (error) => {
                // console.log("error user session: "+JSON.stringify(error));
                // user session is invalid
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

            });


        });

    }

    componentDidMount() {

        let self = this;
        self.initializeDateTime();
        self.getLocationDetailWithPvtConfig();
    }

    getLocationDetailWithPvtConfig() {

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();

        let activeLocation = this.props.activeLocation;
        let locId = activeLocation.objectId;

        let self = this;

        self.setState({
            isLoaded : false
        });

        Api.getLocationDetail(locId, userId, sessionToken)
            .then(
                (result) => {
                    const locationDetail = result.data;

                    self.setState({
                        activeLocation: locationDetail,
                        isLoaded : true
                    });

                },
                (error) => {
                    if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
                        console.log("Error occured while fetching the location data!" + JSON.stringify(error));
                        this.setState({isLoaded : true });
                        alert(error.responseJSON.error.message);
                    }
                    Utils.checkErrorIsInvalidSessionToken(error,this.context.router);
                });
    }

    onDateSelectionChanged(fromDate, toDate) {

        this.setState({
            fromDate, toDate,
            isLoaded: false,
            ordersData:[],
            limit : CONFIG_HELPER.DEFAULT_ORDER_LIMIT,
            skip : 0,
            totalOrderCount : 0,
            isPrevBtnActive: 'disabled',
            isNextBtnActive: 'disabled'
        }, () => {
            this.fetchOrderDetails();
        });
    }

    loadModalPopup(rowVal) {
        this.setState({
            order: rowVal,
            showChargeDetails: false
        },()=>{
            this.showOrderDetailsModal();
        });

    }

    loadChargeModalPopup(charge) {
        let customCharges = charge;
        this.setState({
            chargeData: customCharges,
            showOrderModal: false
        },()=>{
            this.showChargeDetailsModal();
        });

    }

    /*  Set default timezone on moment  */
    setLocationTimeZoneInMoment(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);

        // console.log(moment());
        return moment();
    }

    fetchOrderDetails() {

        if (!this.state.activeLocation) {
            return;
        }

        let self = this;
        self.setState({
            isLoaded : false
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = self.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let fromDate = self.state.fromDate;
        let toDate = self.state.toDate;
        let limit = self.state.limit;
        let skip = self.state.skip;


        // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
        // let fromDateTime =  moment.tz(fromDate, this.state.timeZone).local().format('YYYY-MM-DD');
        let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
        let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);


        const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};

        // console.log(dateRange);

        Api.getOrdersAt(
            userId, sessionToken, dateRange, locId, limit, bizId, skip
        ).then((response) => {
                // console.log(JSON.stringify(response));
                self.parseOrderData(response);
            },
            (error) => {
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
            });
    }



    parseOrderData(orderResponseData){
        let timeZone = this.state.activeLocation.timeZone;
        let self = this;
        if (orderResponseData.data && orderResponseData.data.length > 0) {
            const results = orderResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};
                Object.keys(columns).forEach(col => {
                    if (col === "orderType") {
                        newTable[col] = Utils.getOrderTypeStr(result);
                    }
                    else if (col === "orderItems") {
                        newTable[col] = result;
                    }
                    else {
                        newTable[col] = result[col];
                    }
                });

                self.state.ordersData.push(newTable);
            });

            self.setState({
                isLoaded: true,
                totalOrderCount: orderResponseData.count
            },()=> {
                self.setPrevAndNextBtnClass();
            });

        }
        else {
            self.setState({
                isLoaded: true
            });
        }

    }

    componentWillMount() {

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);

        this.setState({
            activeLocation: this.props.activeLocation,
            timeZone: timeZone
        });
    }

    componentWillReceiveProps(nextProps) {
        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if (currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if (nextProps !== null
            &&
            nextProps.activeLocation !== null
            &&
            nextProps.activeLocation.objectId !== locId
        ) {
            this.setState({
                    // google: nextProps.google,
                    activeLocation: nextProps.activeLocation,
                    timeZone: Utils.extractTimeZoneFromLocation(nextProps.activeLocation),
                    ordersData:[],
                    skip : 0,
                    totalOrderCount : 0,
                },
                () => {
                    this.initializeDateTime();
                });
        }
    }

    fetchLocationDetails = () => {

        if (!this.state.activeLocation) {
            return;
        }

        const locId = this.state.activeLocation.objectId;

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let self         = this;

        Api.getLocationDetail(locId, userId, sessionToken)
            .then(
                (result) => {
                    const locationDetail = result.data;
                    if (locationDetail) {
                        const privateData = locationDetail["privateData"];
                        if (privateData && privateData.stripeCredentials && privateData.stripeCredentials.stripe_user_id) {
                            let stripUserId = privateData.stripeCredentials.stripe_user_id;
                            this.setState({
                                stripeUserId: stripUserId
                            });
                        }
                    }
                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded : false });
                    // console.log("Error occured while fetching latest user data!");
                }
            );
    }

    showOrderDetailsModal = () => {
        // disable the body scroll
        $("body").css('overflow', 'hidden');
        this.setState({
            showOrderModal: true
        });
    }
    hideOrderDetailsModal = () => {
        // enable the body scroll
        $("body").css('overflow', 'auto');
        this.setState({
            showOrderModal: false
        });
    }
    showChargeDetailsModal = () => {

        // disable the body scroll
        $("body").css('overflow', 'hidden');
        this.setState({
            showChargeDetails: true
        });
    }
    hideChargeDetailsModal = () => {
        // enable the body scroll
        $("body").css('overflow', 'auto');
        this.setState({
            showChargeDetails: false
        });
    }
    showExportModal = () => {
        // disable the body scroll
        $("body").css('overflow', 'hidden');
        this.setState({
            showExportModal: true
        });
    }
    hideExportModal = () => {
        // enable the body scroll
        $("body").css('overflow', 'auto');
        this.setState({
            showExportModal: false
        });
    }

    btnPrevClick() {

        let skipLimit = this.state.skip - this.state.limit;
        this.setState({
            ordersData:[],
            skip : skipLimit,
            // totalOrderCount : 0
        },()=>{
            this.fetchOrderDetails();
        });

    }

    btnNextClick() {

        let skipLimit = this.state.skip + this.state.limit;
        this.setState({
            ordersData:[],
            skip : skipLimit,
            // totalOrderCount : 0
        },()=>{
            this.fetchOrderDetails();
        });
    }

    setPrevAndNextBtnClass(){

        let skip = this.state.skip;
        let limit = this.state.limit;
        let skipLimit = skip + limit;
        let totalOrderCount = this.state.totalOrderCount;

        if (totalOrderCount > limit){

            this.setState({pagination: true});

            if (skipLimit <=limit){
                this.setState({isPrevBtnActive: 'disabled'});
            }
            else {
                this.setState({isPrevBtnActive: ''});
            }

            if (skipLimit >= totalOrderCount){
                this.setState({isNextBtnActive: 'disabled'});
            }
            else {
                this.setState({isNextBtnActive: ''});
            }
        }
        else {
            this.setState({pagination: false});
        }
    }

    render() {
        // var timeString = "2019-08-06T06:59:59.999Z";
        // console.log(moment.tz(timeString, "America/Los_Angeles").toString());

        let stripUserId = this.state.stripeUserId;
        // var stripUrl= "https://dashboard.stripe.com/"+stripUserId+"/payments/";
        let chargeTag = this.state.chargeData.tag;
        let chargeTagTitle = "Charge  '"+chargeTag+"' Details";


        columns["name"] = {
            ...columns.name,
            Cell: rowVal =>{

                let userInfo = rowVal.orderItems.userInfo;

                let comp = "";

                if(!Utils.isEmptyObj( userInfo )){
                    comp = (
                        <span className="user_info">
                            <p>{userInfo.name}</p>
                            <p>{Utils.formatPhoneNumber(userInfo.phone)}</p>
                        </span>
                    )
                    return comp;
                }else{
                    return null
                }

            }
        }

        columns["orderType"] = {
            ...columns.orderType,
            Cell: rowVal =>{

                    let comp = (
                        <span className="ordertype_info">
                            <p>{rowVal.orderType}</p>
                        </span>
                    )

                return comp;

            }
        }

        // set custom button in the table column
        columns["orderItems"] = {
            ...columns.orderItems,
            Cell: rowVal => (
                <button style={{cursor:'pointer'}} data-target="#myModal" data-toggle="modal" data-backdrop="static" data-keyboard="false" onClick={_ => this.loadModalPopup(rowVal.orderItems)} type="button" className="btn btn-link search-order-details">
                    {/* <i className="fa fa-search" aria-hidden="true"></i> */}
                    <img src={Search_Icon} alt="" height="25" width="23"/>
                    {/* Show */}
                </button>)
        };

        columns["orderNum"] = {
            ...columns.orderNum,
            Cell: rowVal =>(<button style={{cursor:'pointer'}} onClick={_ => this.loadModalPopup(rowVal.orderItems)} type="button" className=" font-bold btn-link btn-order-num">
                {rowVal.orderNum}
            </button>)
        };

        columns["orderState"] = {
            ...columns.orderState,
            Cell: rowVal => {
                let orderType = rowVal.orderType;
                let orderState = rowVal.orderState;
                let orderStatus = orderState;
                let iconColor =  "green";
                let faIcon      = "fa-check-circle";

                if(orderState === CREATED){
                    orderStatus = " New";
                    iconColor =  "green";
                }

                if(orderState === ACCEPTED){
                    orderStatus = " Order Accepted";
                    iconColor =  "green";
                }

                if(orderState === REJECTED){
                    orderStatus = "  Rejected";
                    iconColor =  "red";
                    faIcon = "fa-ban";
                }

                if(orderState === NOT_COMPLETED){
                    orderStatus = " Not Completed";
                    iconColor =  "red";
                    faIcon = "fa-ban";
                }

                if(orderType === PICKUP || orderType ===  CURBSIDE_PICKUP){
                    if(orderState === READY_FOR_PICKUP){
                        orderStatus = "Ready for Pick Up";
                        iconColor =  "green";

                    }

                    if(orderState === PICKED_UP){
                        orderStatus = " Picked Up";
                        iconColor =  "green";
                    }
                }

                if(orderType === DELIVERY){
                    if(orderState === DELIVERED){
                        orderStatus = " Delivered";
                        iconColor =  "green";
                    }

                    if(orderState === OUT_FOR_DELIVERY){
                        orderStatus = " Out For Delivery";
                        iconColor =  "green";
                    }
                }

                //
                // console.log("orderStatus readyPickup: " + orderStatus)

                let comp = (
                    <p className="order-state">
                        <i className={`fa ${faIcon} fa-1x`} style={{color:`${iconColor}`}}></i> {orderStatus}
                    </p>
                )

                return comp;
            }
        };

        columns["createdAt"] = {
            ...columns.createdAt,
            // let createdAt = moment(result[col]);
            Cell: rowVal => {
                let createdAt = rowVal.createdAt;

                let comp = "";

                if(!Utils.isEmpty(createdAt)){
                    let date = moment(createdAt).format("h:mm a, ddd,");
                    let time = moment(createdAt).format("MMMM Do, YYYY");
                    comp = (
                        <span className="scheduled-comp">
                            <p>{date}</p>
                            <p>{time}</p>
                        </span>
                    );

                    return comp;
                } else {
                    return null;
                }
            }
        }

        columns["userType"] = {
            ...columns.userType,

            Cell: rowVal => {
                let userInfo = rowVal.orderItems.userInfo;

                let comp = null;

                if (!Utils.isEmptyObj(userInfo) && userInfo.hasOwnProperty("userType") && userInfo.userType == "guest") {
                    comp = (
                        <p className="order-state">
                            Guest User
                        </p>
                    );
                }

                return comp;
            }
        }

        columns["scheduledAt"] = {
            ...columns.scheduledAt,

            Cell: rowVal => {
                let scheduledAt = rowVal.scheduledAt;


                let comp = "";

                if(!Utils.isEmptyObj(scheduledAt)){
                    let date = moment(scheduledAt.iso).format("h:mm a, ddd,");
                    let time = moment(scheduledAt.iso).format("MMMM Do, YYYY");

                    comp = (
                        <span className="scheduled-comp">
                            <p>{date}</p>
                            <p>{time}</p>
                        </span>
                    );

                    return comp;
                }else{
                    return null;
                }
            }
        }

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}

                {
                    this.state.showOrderModal ? <Modal
                        show={this.state.showOrderModal}
                        closeCallback={this.hideOrderDetailsModal}
                        customClass="custom_modal_class"
                        headerCustomClass={"modal-header-custom"}
                        title={"Order Details"}
                        order={this.state.order}

                    >
                        <div className={"row"}>
                            <OrderDetail
                                order={this.state.order}
                                stripeUserId={this.state.stripeUserId}
                                showCustomChargeModal ={this.loadChargeModalPopup}
                                activeLocation={this.state.activeLocation}
                            />
                        </div>
                    </Modal> : null
                }


                {
                    this.state.showExportModal ? <Modal
                        show={this.state.showExportModal}
                        closeCallback={this.hideExportModal}
                        customClass="custom_modal_class"
                        headerCustomClass={"modal-header-custom"}
                        title={"Export Order Report"}>
                        <div className={""}>
                            <ExportOrder
                                activeLocation={this.props.activeLocation}
                                closeCallback={this.hideExportModal}
                            />
                        </div>
                    </Modal> : null
                }
                {
                    this.state.showOrderRecord ? (
                        <div className="">
                            <div className = "col-md-12 order-container-pg">
                                <div className="row">
                                    <div className={"col-sm-12 no-gutter ml-10"}>
                                        <DateRangePickerFilter
                                            className={"datepicker-container"}
                                            fromMessage={"Select date range (max 100 days)"}
                                            defaultDateRangeDays={"100"}
                                            startDefaultFromDays={"6"}
                                            allowMinPastYear={"2"}
                                            timeZone = {this.state.timeZone}
                                            callBackParent={this.onDateSelectionChanged}
                                        />

                                        <div className="col-sm-3 no-gutter text-center export-btn-container">
                                            <button className={"btn btn-primary mr-20"} onClick={this.showExportModal} style={{float:"right"}}><i className="fa fa-file-excel-o" aria-hidden="true"></i> Export</button>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="">
                                <div className="col-md-12 text-center">
                                    <h4 className="h-small"><b>Orders
                                        from {Utils.getDateString(this.state.fromDate, this.state.timeZone)} to {Utils.getDateString(this.state.toDate, this.state.timeZone)}
                                    </b>
                                    </h4>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {
                                    this.state.totalOrderCount > 0 ?
                                        <TableHolderCustom
                                            columns={columns}
                                            tableData={this.state.ordersData}
                                            isPrevBtnActive={this.state.isPrevBtnActive}
                                            isNextBtnActive={this.state.isNextBtnActive}
                                            btnPrevClick={this.btnPrevClick}
                                            btnNextClick={this.btnNextClick}
                                            countDefault={this.state.skip}
                                            pagination={this.state.pagination}
                                            customClass={"table-responsive"}
                                        /> :
                                        <div className="col-md-12 text-center">
                                            <h4 className="h-small">No record found
                                            </h4>
                                        </div>
                                }
                            </div>
                        </div>
                    ) : null
                }

            </div>
        );
    }

}




// WEBPACK FOOTER //
// src/components/visualization/stats2-table.js